// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__DfNTW","bg":"Intro_bg__1ckwl","logo":"Intro_logo__kAYby","begin":"Intro_begin__pbDDM"};